import React, { useState } from 'react';
import './ExploratoryAnalysis.css';

export default function ExploratoryAnalysis() {
  const [selectedSample, setSelectedSample] = useState('None');

  return (
    <div className="ea-container">
      <aside className="ea-sidebar">
        <div className="ea-logo">Exploratory Analysis</div>

        <nav className="ea-nav">
          <div className="nav-item pca">
            <button className="nav-btn">PCA</button>
            <div className="submenu">
              <button
                className="submenu-item"
                onClick={() => setSelectedSample('Sample 1')}
              >
                Sample 1
              </button>
              <button
                className="submenu-item"
                onClick={() => setSelectedSample('Sample 2')}
              >
                Sample 2
              </button>
            </div>
          </div>

          <div className="nav-item">
            <button className="nav-btn">Apply</button>
          </div>

          <div className="nav-item">
            <button className="nav-btn">Density Exploration</button>
          </div>
        </nav>

        <div className="ea-footer">v1.0</div>
      </aside>

      <main className="ea-main">
        <div className="ea-top-controls">
          <div className="ea-search">PCA</div>
          <div className="ea-actions">
            <button className="action-btn">Apply</button>
            <button className="action-btn">Reset</button>
          </div>
        </div>

        <section className="ea-canvas">
          <h2>Selected: {selectedSample}</h2>
          <div className="placeholder">
            {/* Replace with real chart / content */}
          </div>
        </section>
      </main>
    </div>
  );
}